module.exports = __webpack_public_path__ + "static/media/introduce_base6.be944e86.png";